// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--L1ZnK","titleLink":"header-module--titleLink--QjC5q","title":"header-module--title--EMxyd","tagline":"header-module--tagline--Rgw0F"};